import { ChartLine, Files, Info, Table } from "lucide-react";
import { Link, useLocation } from "react-router";

import {
  RobotoDivider,
  RobotoStyledTab,
  RobotoStyledTabs,
} from "@/shared/components";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks/useCheckFeatureFlag";

import styles from "./SessionDetail.module.css";
import { SessionTab, useActiveSessionTab } from "./useActiveSessionTabFromUrl";

/**
 * Tab strip for the session-detail page. Reads its active value from
 * the URL via `useActiveSessionTab`, so it carries no session-record
 * dependency and can render unconditionally — including inside the
 * page's error fallback when the session fetch fails.
 */
export function SessionTabBar() {
  const activeTab = useActiveSessionTab();
  const location = useLocation();
  const metricsTabEnabled = useCheckFeatureFlag("release-metrics");

  return (
    <div className={styles.tabBar}>
      <RobotoStyledTabs value={activeTab} aria-label="session tabs">
        <RobotoStyledTab
          value={SessionTab.Topics}
          label="Topics"
          icon={<Table size="1em" className={styles.tabIcon} />}
          iconPosition="start"
          component={Link}
          to={{ pathname: SessionTab.Topics, search: location.search }}
          replace
        />
        <RobotoStyledTab
          value={SessionTab.Sources}
          label="Sources"
          icon={<Files size="1em" className={styles.tabIcon} />}
          iconPosition="start"
          component={Link}
          to={{ pathname: SessionTab.Sources, search: location.search }}
          replace
        />
        {metricsTabEnabled && (
          <RobotoStyledTab
            value={SessionTab.Metrics}
            label="Metrics"
            icon={<ChartLine size="1em" className={styles.tabIcon} />}
            iconPosition="start"
            component={Link}
            to={{ pathname: SessionTab.Metrics, search: location.search }}
            replace
          />
        )}
        <RobotoStyledTab
          value={SessionTab.Details}
          label="Details"
          icon={<Info size="1em" className={styles.tabIcon} />}
          iconPosition="start"
          component={Link}
          to={{ pathname: SessionTab.Details, search: location.search }}
          replace
        />
      </RobotoStyledTabs>
      <RobotoDivider />
    </div>
  );
}
